
import {
    apiSettingsImgtoolGetLogList
} from '@/api/setting'
import { Component, Prop, Vue } from 'vue-property-decorator'
import LsPagination from '@/components/ls-pagination.vue'
import { RequestPaging } from '@/utils/util'
import LsDialog from '@/components/ls-dialog.vue'
@Component({
    components: {
        LsDialog,
        LsPagination
    }
})
export default class Task extends Vue {
    // 分页
    pager: RequestPaging = new RequestPaging();
    apiSettingsImgtoolGetLogList = apiSettingsImgtoolGetLogList

    // 获取列表
    getList() {
        this.pager.request({
            callback: apiSettingsImgtoolGetLogList,
            params: {}
        })
    }




    created() {
        this.getList()
    }
}
